import React from 'react'
import {TicketAvatarProps} from './types'
import TicketAvatarView from './TicketAvatarView'

const TicketAvatar = (props: TicketAvatarProps): React.ReactElement => <TicketAvatarView {...props} />

export default TicketAvatar
